var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wxlogin',{staticClass:"wecat-login",attrs:{"appid":_vm.appid,"state":new Date().getTime().toString(),"scope":"snsapi_login","redirect_uri":_vm.redirectUri,"href":"data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZxxx="}})}
var staticRenderFns = []

export { render, staticRenderFns }